// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown--IvxKI","clearColor":"clearColor--raTs2","color":"color--F5LXz"};